import { render, staticRenderFns } from "./Hotspots2.vue?vue&type=template&id=327c860f"
import script from "./Hotspots2.vue?vue&type=script&lang=js"
export * from "./Hotspots2.vue?vue&type=script&lang=js"
import style0 from "./Hotspots2.vue?vue&type=style&index=0&id=327c860f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports